export function calcMaxAgentPrice(groupPrice, grossProfit, pddDeduction, postage) {
	const price = Number(groupPrice) || 0
	const gross = Number(grossProfit) || 0
	const deduct = Number(pddDeduction) || 0
	const ship = Number(postage) || 0
	const result = price - price * gross / 100 - price * deduct / 100 - ship
	return Math.max(0, Math.round(result))
}

export function normalizePriceValue(value) {
	if (value == null || value === '') {
		return undefined
	}
	const num = Number(value)
	if (isNaN(num)) {
		return value
	}
	return Math.round(num)
}

function buildChannelLegendRow() {
	return {
		shop_name: '渠道/组',
		_legend: true,
		_checked: false,
		_indeterminate: false,
	}
}

export function appendChannelLegendRow(channelBlocks) {
	if (!channelBlocks || !channelBlocks.length) {
		return channelBlocks
	}
	return channelBlocks.map(function(block) {
		const tablelist = Array.isArray(block.tablelist) ? block.tablelist : []
		const withoutLegend = tablelist.filter(function(row) {
			return !row._legend
		})
		const channelRows = withoutLegend.filter(function(row) {
			return !row._summary
		})
		if (!channelRows.length) {
			return Object.assign({}, block, { tablelist: withoutLegend })
		}
		const summaryRows = withoutLegend.filter(function(row) {
			return row._summary
		})
		return Object.assign({}, block, {
			tablelist: summaryRows.concat([buildChannelLegendRow()]).concat(channelRows),
		})
	})
}



// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/channelConfigTableMock.js